// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 6956) return "6956.bundle.css";
if (chunkId === 347) return "347.bundle.css";
if (chunkId === 6722) return "6722.bundle.css";
if (chunkId === 2478) return "2478.bundle.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}